module.exports = __webpack_public_path__ + "static/media/14B.9a59b402.png";